export const ugovor_o_kupoprodaji = {
    templateId: 43,
    category: 16,
    templateTitle: 'Ugovor o kupoprodaji',
    templateDescription: `<p>Ugovorom o kupoprodaji prodavatelj se obvezuje predati kupcu stvar u vlasništvo, a kupac se obvezuje prodavatelju platiti cijenu.</p>`,
    description: `
    <h5><strong>OPIS I SVRHA DOKUMENTA</strong></h5>
    <p>Ugovorom o kupoprodaji prodavatelj se obvezuje predati kupcu stvar u vlasništvo, a kupac se obvezuje prodavatelju platiti cijenu.</p>
    <p><strong>Bitni sastojci ugovora u kupoprodaji su:</strong></p>
    <p><strong>- stvar (uključujući prava i imovinu),</strong></p>
    <p><strong>- cijena.</strong></p>
    <p>Ako ugovorom o kupoprodaji cijena nije određena, a ugovor ne sadrži dovoljno podataka s pomoću kojih bi se ona mogla odrediti, ugovor nema pravni učinak.</p>
    <p><strong>Najvažnije obveze prodavatelja su predaja stvari i odgovornost za ​nedostatke.</strong></p>
    <p><strong>Najvažnije obveze kupca su platiti cijenu i preuzeti stvar.</strong></p>
    <p>Kao čestu ugovornu odredbu kod ugovora o kupoprodaji roba ističe se odredba o paritetu kojom se određuje koje sve troškove i rizike u vezi s dopremom robe snosi prodavatelj, a koje kupac.</p>
    <p>U tom smislu, najčešće se upotrebljava klauzula franco (franko; FCO) koja predstavlja trgovačku klauzulu kojom se prodavatelj obvezuje da prema ugovorenoj cijeni isporuči ili stavi kupcu na raspolaganje robu o svojem trošku na utvrđenom mjestu.</p>
    <p>Npr. izraz franko (FCO) sjedište prodavatelja znači da je prodavatelj dužan staviti robu na raspolaganje kupcu u određeno vrijeme u sjedištu prodavatelja, pri čemu kod preuzimanja robe kupac snosi sve troškove nakon preuzimanja. Isto znače, npr. klauzule franko mlin, franko skladište, franko plantaža, franko tvornica, franko kupac i sl.</p>
    <p>Ipak, radi lakšeg reguliranja međusobnih obveza oko prijevoza i preuzimanja robe, Međunarodna trgovačka komora uspostavila je tzv. INCOTERMS paritete koji predstavljaju standard te su uobičajeni u praksi, a po njima presuđuju i svi svjetski sudovi, arbitraže i sl.</p>
    <p>Uključivanje Incoterms klauzula (pariteta) u ugovore o kupoprodaji (moguće ih je unijeti i u ugovore između poslovnih subjekata koji imaju sjedište u Republici Hrvatskoj) znatno smanjuje mogućnosti nesporazuma koji bi mogli dovesti do sporova pa je slijedom toga vrlo bitno i njihovo poznavanje odnosno točno reguliranje kroz unošenje u ugovor.</p>
    <p>Neke od najčešćih INCOTERMS klauzula su:</p>
    <p>● EXW​ - franko tvornica, kupac preuzima robu i odgovornost u tvornici prodavatelja, prodavatelj ne snosi nikakve ostale troškove.</p>
    <p>● FCA​ - franko prijevoznik (uz naznaku mjesta), prodavatelj predaje izvozno ocarinjenu robu u ruke prijevoznika kojeg odabire kupac.</p>
    <p>● DAP​ - isporučeno na mjestu (uz naznaku mjesta), prodavatelj stavlja robu na raspolaganje kupcu na dolaznom prijevoznom sredstvu pripremljeno za iskrcaj, snosi trošak i rizik dok roba nije isporučena uključujući izvozne carinske formalnosti i tranzit kroz treću zemlju. Kupac mora preuzeti robu te snosi rizik i trošak nakon što je roba isporučena uključujući iskrcaj, uvozne formalnosti, carinu, porez i ostale troškove nakon uvoza.</p>
    <p>● DDP​ - isporučeno ocarinjeno (uz naznaku mjesta), prodavatelj snosi sve troškove transporta i sav rizik do dostave i carinjenja robe.</p>
    <p>Za detaljniji prikaz INCOTERMS klauzula pogledajte <a target="_blank" href="https://www.hrvatski-izvoznici.hr/Cms_Data/Contents/hiz/Folders/dokumenti/~contents/BGL2KREHASERPNEM/incoterms-oznake.pdf">ovdje</a>.</p>
    <p><strong>Ovaj primjer ugovora o kupoprodaji ne primjenjuje se na kupoprodaje nekretnina, poslovnih prostora, motornih vozila i sl., a koje su određene posebnim propisima te imaju drugačije obvezne sastojke od primjera u nastavku.</strong></p>
    <p>Ovom primjeru ugovora o kupoprodaji mogu se dodati (oznaka dodaj članak) određene specifične odredbe koje se odnose na posebne pogodbe kod kupoprodaje: pravo prvokupa, pridržaj prava vlasništva i sl..</p>
    <h5><strong>NAJČEŠĆE GREŠKE</strong></h5>
    <p><strong>- Ugovaranje rokova plaćanja među poduzetnicima drugačijih od rokova plaćanja propisanih Zakonom o financijskom poslovanju i predstečajnoj nagodbi</strong></p>
    <p>Pojašnjenje: u poslovnim transakcijama među poduzetnicima može se ugovoriti rok ispunjenja novčane obveze do 60 dana. Ako ugovorom među poduzetnicima nije ugovoren rok za ispunjenje novčane obveze, dužnik je dužan, bez potrebe da ga vjerovnik na to pozove, ispuniti novčanu obvezu u roku od 30 dana. Ipak, kod ugovora o robno trgovačkom kreditu može se ugovoriti u pisanom obliku i dulji rok ispunjenja novčane obveze, a koji rok ni u kojem slučaju ne može biti dulji od 360 dana, no pod uvjetom da takvo ugovaranje na temelju okolnosti slučaja (trgovački običaji i narav obveze i sl.) nije suprotno načelu savjesnosti i poštenja odnosno da takvim ugovaranjem nije prouzročena očigledna neravnopravnost u pravima i obvezama ugovornih strana na štetu vjerovnika novčane obveze.</p>
    <p>Rok za ispunjenje novčane obveze počinje teći od:</p>
    <p>1. dana kad je dužnik primio račun ili drugi odgovarajući zahtjev za isplatu,</p>
    <p>ili</p>
    <p>2. dana kad je vjerovnik ispunio svoju obvezu:</p>
    <p>– ako nije moguće sa sigurnošću utvrditi dan primitka računa ili drugog odgovarajućeg zahtjeva za isplatu ili,</p>
    <p>– ako je dužnik primio račun ili drugi odgovarajući zahtjev za isplatu prije negoli je vjerovnik ispunio svoju obvezu,</p>
    <p>ili</p>
    <p>3. dana isteka roka za pregled predmeta obveze (rok za pregled obveze ne može biti duži od 30 dana od primitka predmeta obveze, iznimno može i duži rok pod uvjetima određenim Zakonom), ako je ugovorom ili zakonom predviđen određeni rok za takav pregled, a dužnik je primio račun ili drugi odgovarajući zahtjev za isplatu prije isteka toga roka.</p>
    <p>Ništetna je (smatra se da nije niti ugovorena te ne proizvodi pravne učinke) odredba ugovora među poduzetnicima kojom je ugovoren:</p>
    <p>1. rok ispunjenja novčane obveze duži od 60 dana,</p>
    <p>2. rok za pregled predmeta obveze duži od 30 dana, ako na temelju okolnosti slučaja, a posebno trgovačkih običaja i naravi predmeta obveze, proizlazi da je takvom ugovornom odredbom, suprotno načelu savjesnosti i poštenja, prouzročena očigledna neravnopravnost u pravima i obvezama ugovornih strana na štetu vjerovnika novčane obveze,</p>
    <p>3. rok ispunjenja novčane obveze duži od 360 dana - a ne postoje okolnosti iz prethodne točke.</p>
    <p>Osim toga, poduzetnik koji ne ispuni novčanu obvezu u roku ugovorenom sukladno odredbama gore spomenutog Zakona, odnosno u zakonskom roku ispunjenja novčane obveze odgovara prekršajno do iznosa od 1.000.000,00 kn.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o obveznim odnosima, Zakon o financijskom poslovanju i predstečajnoj nagodbi.</p>
  `,

    sides: [
        {
            signature: 'Prodavatelj:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Prodavatelj)',
            delimiter: `i`
        },
        {
            signature: 'Kupac:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: 'Posl. subjekt / Ime i prezime',        
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                mandatory: false,
                editable: true,
                placeholder: "Zastupa (za pr. osobe)",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija (za pr. osobe)",
                inSignature: true,
              }],
            suffix: ' (u daljnjem tekstu: Kupac),'
        }
    ],

    headline: 'zaključuju sljedeći',
    title: 'UGOVOR O KUPOPRODAJI',
    noArticleNumbers: false,

    articles: [

        {
            title: 'PREDMET UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Predmet ovog Ugovora je kupoprodaja:'},
                        {type: 'textarea', value: '', required: true, help: 'Ovdje pobliže opisujete predmet kupoprodaje.'},
                        {type: 'text', content: '(u daljnjem tekstu: Predmet kupoprodaje).'},],
                  
                    }],
        }, 
        {
            title: 'KOLIČINA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Kupac kupuje, a Prodavatelj prodaje Predmet kupoprodaje u količini od'},
                        {type: 'input', value: '', required: true, help: 'Potrebno je upisati količinu.'},
                        {type: 'text', content: ','},
                        {type: 'input', value: '', required: true, help: 'Potrebno je upisati mjernu jedinicu.'},
    ],
                }],
        },
        {
            title: 'KVALITETA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Predmet kupoprodaje ima sljedeću kvalitetu'},
                        {type: 'textarea', value: '', required: true, help: 'Upisati kvalitetu predmeta kupoprodaje.'},],
                    }],
        },
        {
            title: 'CIJENA',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'Cijena za Predmet kupoprodaje iznosi'},
                        {type: 'input', value: '', required: true, help: 'Potrebno je upisati cijenu.'},
        ],
                }],
        },
        {
            title: 'ROK ISPORUKE',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Predmet kupoprodaje će biti isporučen dana'},
                                {type: 'input', value: '', required: true, help: 'Upisati trenutak isporuke predmeta kupoprodaje.'},
                              ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Predmet kupoprodaje će biti isporučen najkasnije do dana'},
                                {type: 'input', value: '', required: true, help: 'Upisati krajnji rok isporuke.'},
                            ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Predmet kupoprodaje će biti isporučen u roku od'},
                                {type: 'input', value: '', required: true, help: 'Upisati rok isporuke.'},
                                {type: 'text', content: 'od dana'},
                                {type: 'input', value: '', required: true, help: 'Prethodno u ovoj rečenici upisati rok, a onda ovdje i događaj od kojega se računa rok isporuke.'},
            ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'MJESTO ISPORUKE, PARITET',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Predmet kupoprodaje će biti isporučen u'},
                        {type: 'input', value: '', required: true, help: 'Upisati mjesto isporuke.'},
                        {type: 'text', content: 'na paritetu'},
                        {type: 'input', value: '', required: true, help: 'Upisati paritet. Prethodno pogledati uvodni tekst gore.'},
           ],
                }],
        },
      
        {
            title: 'NEDOSTACI',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {
                            type: 'text',
                            content: 'Kupac će pregledati Predmet kupoprodaje prilikom preuzimanja te je na vidljive nedostatke dužan prigovoriti u roku'
                        },
                        {type: 'input', value: '', required: true, help: 'Upisati rok.'},
                        {type: 'text', content: ', a na skrivene nedostatke u roku od'},
                        {type: 'input', value: '', required: true, help: 'Upisati rok.'},
        ],
                }],
        },
        {
            title: 'ROK PLAĆANJA',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {type: 'text', content: 'Kupac je dužan platiti cijenu Prodavatelju za Predmet kupoprodaje u roku od '},
                                {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.Prethodno pogledati uvodni tekst prije dokumenta.'},
                                {type: 'text', content: 'dana od dana isporuke.'}]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Kupac je dužan platiti cijenu Prodavatelju za Predmet kupoprodaje u roku od '},
                                {type: 'input', value: '', required: true, help: 'Upisati rok plaćanja.Prethodno pogledati uvodni tekst prije dokumenta.'},
                                {type: 'text', content: 'dana od primitka računa.'}]
                        },
                {
                    parts: [
                      { type: "text", content: "Kupac je dužan platiti cijenu Prodavatelju za Predmet kupoprodaje u sljedećim rokovima:" },
                      { type: "textarea", value: "", required: true },
                      { help: 'Upisati rokove plaćanja. Prethodno pogledati uvodni tekst gore.'}
                    ]
                  }
                ],
                value: "",
              },
            ]
          },
        {
            title: 'SREDSTVO OSIGURANJA PLAĆANJA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Kao sredstvo osiguranja podmirenja obveza po ovom Ugovoru, Kupac će odmah predati Prodavatelju'
                                },
                                {type: 'textarea', value: '', required: true, help: 'Upisati sredstvo osiguranja plaćanja, ukoliko želite ugovoriti isto.'},
                    ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Kao sredstvo osiguranja podmirenja obveza po ovom Ugovoru, Kupac će u roku od'},
                                {type: 'input', value: '', required: true, help: 'Upisati kada će Kupac predati sredstvo osiguranja.'},
                                {type: 'text', content: 'predati Prodavatelju'},
                                {type: 'textarea', value: '', required: true, help: 'Upisati sredstvo osiguranja plaćanja, ukoliko želite ugovoriti isto.'},
         ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'TRAJANJE UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Ovaj ugovor zaključuje se isključivo za kupoprodaju navedenu u ovom Ugovoru i prestaje urednim izvršenjem svih međusobnih obveza ugovorenih strana iz ovog Ugovora.'
                                }]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'Ovaj Ugovor se zaključuje na razdoblje'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum početka Ugovora.'},
                                {type: 'text', content: 'od'},
                                {type: 'input', value: '', required: true, help: 'Upišite datum završetka Ugovora. '},
             ]
                        }],
                    value: '',
                }
            ]
        },
        {
            title: 'OTKAZ UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {
                            type: 'text',
                            content: 'Svaka ugovorna strana može jednostrano, pisanim putem, bez navođenja razloga, pisanim putem otkazati ovaj Ugovor uz otkazni rok od'
                        },
                        {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                        {type: 'text', content: 'dana, a koji počinje teći od trenutka dostave otkaza drugoj ugovornoj strani.'},
                                    {type: 'text', newline:"true", content: '\r\nUčinci takvog prestanka ugovora uslijed otkaza su sljedeći:', help: 'Učinke otkaza možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'},
                                    { type: "textarea", value: "", required: true },
                                    { help: 'Ovdje definirate učinke prestanka ugovora uslijed otkaza.',}],
                }],
        },
        {
            title: 'RASKID UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text', content: 'U slučaju da jedna ugovorna strana krši obveze iz ovog Ugovora, druga strana može pisanim putem jednostrano raskinuti ugovor uz otkazni rok od' },
                                    {type: 'input', value: '', required: true, help: 'Upisati otkazni rok.'},
                                    {type: 'text', content: ', a koji počinje teći od trenutka dostave raskida drugoj ugovornoj strani.'},
                                    {type: 'text', newline:"true", content: '\r\nPosljedice takvog raskida su sljedeće:'},
                                    { type: "textarea", value: "", required: true },
                                    { help: 'Učinke raskida možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'}
                    ]
                        },
                        {
                            parts: [
                                {type: 'text', content: 'U slučaju da Kupac ne podmiri Prodavatatelju kupoprodajni iznos u cijelosti do dana'},
                                {type: 'input', value: '', required: true, help: 'Upisati datum.'},
                                {type: 'text', content: ', ovaj ugovor se automatski raskida sa sljedećim učincima:'},
                                { type: "textarea", value: "", required: true },
                                { help: 'Učinke raskida možete ugovarati slobodno po vlastitom nahođenju, kao i eventualne ugovorne kazne.'},
         ]
                        }],
                }
            ]
        },
        {
            title: 'DOSTAVA',
            mandatory: false,
            exampleContent: true,
            statements: [
                {
                    type: 'text',
                    required: true,
                    mandatory: true,
                    editable: true,
                    content: 'U slučaju otkaza i raskida Ugovora, isti se mora drugoj ugovornoj strani dostaviti preporučenom pošiljkom putem pošte na adresu označenu u ovom Ugovoru ili na drugi pouzdan način.\r\nU slučaju nemogućnosti uredne osobne dostave pisane opomene i dostave otkaza zbog promjene adrese, odbijanja preuzimanja pismena ili drugih načina izbjegavanja primanja pismena, dostava se smatra uredno izvršenom danom predaje preporučene pošiljke pošti, bez obzira na to je li pošta bila u mogućnosti uručiti pisanu opomenu, odnosno otkaz ili drugo pismeno.  ',
                    value: '',
                },
            ],
            value: '',
        }, 
        {
            title: 'NADLEŽNOST',
            mandatory: false,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: false,
                    choices: [
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu Prodavatelja.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu Kupca.'
                                }
                            ]
                        },
                        {
                            parts: [
                                {
                                    type: 'text',
                                    content: 'Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u'
                                },
                                {type: 'input', value: '',help: "Upišite mjesno nadležni sud. Npr. sudom u Zagrebu; sudom u Splitu i sl..", required: true},
                         ]
                        }
                    ],
                    value: '',
                }
            ]
        },
        {
            title: 'MJERODAVNO PRAVO',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Na prava i obveze ugovornih stranaka, koja nisu uređena ovim ugovorom, primjenjuju se odredbe Zakona o obveznim odnosima.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJENA UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor se primjenjuje od trenutka potpisa ugovornih strana.',
                    value: '',
                }],
        },
        {
            title: 'PRIMJERCI UGOVORA',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    required: false,
                    mandatory: true,
                    editable: true,
                    content: 'Ovaj Ugovor sastavljen je u 2 (dva) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
                    value: '',
                }],
          },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
    ],
};



// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/43_ugovor_o_kupoprodaji.ts